<template>
	<div class="tempworker-availabilities">
		<div class="tempworker-availabilities__title">
			<strong>Vous êtes <span :class="`tempworker-availabilities__title--${type}`">{{ setup.title }}</span></strong>
		</div>

		<div v-if="type === 'availabilities'">
			Aucun évènement
		</div>
		<div v-if="type === 'specific'">
			<div class="tempworker-availabilities__specific">
				<span> Vous avez saisi une période de disponibilité particulière</span>
				<o-label
					:color="setup.morningColor">
					Matin
				</o-label>
				<o-label
					:color="setup.afternoonColor">
					Après-midi
				</o-label>
				<o-label
					:color="setup.nightColor">
					Soir
				</o-label>
				<o-button
					color="info"
					outline
					@click="setup.openAddSpecificAvailabilitiesAside()">
					Voir cette disponibilité particulière
				</o-button>
				<o-button
					color="danger"
					outline
					@click="setup.deleteSpecificAvailabilityAsync()">
					Supprimer cette disponibilité particulière
				</o-button>
			</div>
		</div>

		<div
			v-if="type === 'unavailabilities'"
			class="tempworker-availabilities__unavailabilities">
			<span> Vous avez saisi une période de non disponibilité :</span>
			<o-datepicker
				v-model="setup.startDate"
				readonly
				label="Date de début"/>
			<o-datepicker
				v-model="setup.endDate"
				readonly
				label="Date de fin"/>
			<o-button
				color="danger"
				outline
				block
				@click="setup.deleteUnavailabilityAsync()">
				Supprimer cette indisponibilité
			</o-button>
		</div>
	</div>
</template>

<script setup lang="ts">
import DashboardTempWorkerAvailabilitiesSetupService from '@/setup/dashboard/temp-worker/DashboardTempWorkerAvailabilitiesSetupService';
const props = defineProps(DashboardTempWorkerAvailabilitiesSetupService.props);
const setup = new DashboardTempWorkerAvailabilitiesSetupService(props);
</script>

<style scoped lang="less">
.tempworker-availabilities {
	background-color: rgb(var(--rgb-grey-light), 0.3);
	border-radius: 0.3rem;
	padding: 1rem;

	&__title {
		position: relative;
		font-size: 1rem;

		&--unavailabilities {
			color: var(--warning)
		}

		&--specific {
			color: var(--info)
		}
	}

	&__specific {
		gap: 0.5rem;
		margin-top: 1rem;
		display: flex;
		justify-content: center;
		flex-direction: column;

		.orion-label {
			justify-content: center;
			display: flex;
			align-items: center;
			height: 2rem;
			font-size: 1rem;
		}

		.orion-button {
			margin-top: 1rem;
		}
	}

	&__unavailabilities {
		:deep(.orion-datepicker) {
			pointer-events: none;
			margin: 1rem 0 1rem;
		}
	}
}
</style>
